module.exports = __webpack_public_path__ + "static/media/zhongxin.6f47174.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/client/zhongxin.mp4
// module id = /Eh9
// module chunks = 0